import c from "./constants";
import { logout } from "../../support/auth";

export function setUserData(data) {
  return { type: c.USER_SET_DATA, payload: data };
}

export const logoutUser = () => {
  const logoutAction = { type: c.USER_LOGOUT };
  logout();
  return dispatch => {
    dispatch(setUserData(null));
    dispatch(logoutAction);
  };
};



// WEBPACK FOOTER //
// ./src/modules/user/actions.js